/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Range_Practice_EyebrowInputs */

const en_range_practice_eyebrow = /** @type {(inputs: Range_Practice_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Practice`)
};

const es_range_practice_eyebrow = /** @type {(inputs: Range_Practice_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Práctica`)
};

const de_range_practice_eyebrow = /** @type {(inputs: Range_Practice_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Üben`)
};

const zh_range_practice_eyebrow = /** @type {(inputs: Range_Practice_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`练习`)
};

const ar_range_practice_eyebrow = /** @type {(inputs: Range_Practice_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التدريب`)
};

const fr_range_practice_eyebrow = /** @type {(inputs: Range_Practice_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entraînement`)
};

const vi_range_practice_eyebrow = /** @type {(inputs: Range_Practice_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luyện tập`)
};

const sw_range_practice_eyebrow = /** @type {(inputs: Range_Practice_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fanya mazoezi`)
};

const th_range_practice_eyebrow = /** @type {(inputs: Range_Practice_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ฝึกฝน`)
};

const bs_range_practice_eyebrow = /** @type {(inputs: Range_Practice_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vježba`)
};

const ja_range_practice_eyebrow = /** @type {(inputs: Range_Practice_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`トレーニング`)
};

const ko_range_practice_eyebrow = /** @type {(inputs: Range_Practice_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`연습`)
};

const pt_range_practice_eyebrow = /** @type {(inputs: Range_Practice_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prática`)
};

const it_range_practice_eyebrow = /** @type {(inputs: Range_Practice_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allenamento`)
};

const sv_range_practice_eyebrow = /** @type {(inputs: Range_Practice_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Öva`)
};

const nl_range_practice_eyebrow = /** @type {(inputs: Range_Practice_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oefenen`)
};

const da_range_practice_eyebrow = /** @type {(inputs: Range_Practice_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Træning`)
};

const nb_range_practice_eyebrow = /** @type {(inputs: Range_Practice_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trening`)
};

const fi_range_practice_eyebrow = /** @type {(inputs: Range_Practice_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harjoittelu`)
};

const pl_range_practice_eyebrow = /** @type {(inputs: Range_Practice_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trening`)
};

const ru_range_practice_eyebrow = /** @type {(inputs: Range_Practice_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Практика`)
};

const tr_range_practice_eyebrow = /** @type {(inputs: Range_Practice_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antrenman`)
};

const hi_range_practice_eyebrow = /** @type {(inputs: Range_Practice_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अभ्यास`)
};

const id_range_practice_eyebrow = /** @type {(inputs: Range_Practice_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Latihan`)
};

const ms_range_practice_eyebrow = /** @type {(inputs: Range_Practice_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Latihan`)
};

const cs_range_practice_eyebrow = /** @type {(inputs: Range_Practice_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trénink`)
};

const el_range_practice_eyebrow = /** @type {(inputs: Range_Practice_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Εξάσκηση`)
};

const he_range_practice_eyebrow = /** @type {(inputs: Range_Practice_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`תרגול`)
};

const af_range_practice_eyebrow = /** @type {(inputs: Range_Practice_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oefening`)
};

const hu_range_practice_eyebrow = /** @type {(inputs: Range_Practice_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gyakorlás`)
};

/**
* | output |
* | --- |
* | "Practice" |
*
* @param {Range_Practice_EyebrowInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const range_practice_eyebrow = /** @type {((inputs?: Range_Practice_EyebrowInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Range_Practice_EyebrowInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_range_practice_eyebrow(inputs)
	if (locale === "de") return de_range_practice_eyebrow(inputs)
	if (locale === "zh") return zh_range_practice_eyebrow(inputs)
	if (locale === "ar") return ar_range_practice_eyebrow(inputs)
	if (locale === "fr") return fr_range_practice_eyebrow(inputs)
	if (locale === "vi") return vi_range_practice_eyebrow(inputs)
	if (locale === "sw") return sw_range_practice_eyebrow(inputs)
	if (locale === "th") return th_range_practice_eyebrow(inputs)
	if (locale === "bs") return bs_range_practice_eyebrow(inputs)
	if (locale === "ja") return ja_range_practice_eyebrow(inputs)
	if (locale === "ko") return ko_range_practice_eyebrow(inputs)
	if (locale === "pt") return pt_range_practice_eyebrow(inputs)
	if (locale === "it") return it_range_practice_eyebrow(inputs)
	if (locale === "sv") return sv_range_practice_eyebrow(inputs)
	if (locale === "nl") return nl_range_practice_eyebrow(inputs)
	if (locale === "da") return da_range_practice_eyebrow(inputs)
	if (locale === "nb") return nb_range_practice_eyebrow(inputs)
	if (locale === "fi") return fi_range_practice_eyebrow(inputs)
	if (locale === "pl") return pl_range_practice_eyebrow(inputs)
	if (locale === "ru") return ru_range_practice_eyebrow(inputs)
	if (locale === "tr") return tr_range_practice_eyebrow(inputs)
	if (locale === "hi") return hi_range_practice_eyebrow(inputs)
	if (locale === "id") return id_range_practice_eyebrow(inputs)
	if (locale === "ms") return ms_range_practice_eyebrow(inputs)
	if (locale === "cs") return cs_range_practice_eyebrow(inputs)
	if (locale === "el") return el_range_practice_eyebrow(inputs)
	if (locale === "he") return he_range_practice_eyebrow(inputs)
	if (locale === "af") return af_range_practice_eyebrow(inputs)
	if (locale === "hu") return hu_range_practice_eyebrow(inputs)
	return en_range_practice_eyebrow(inputs)
});